import { useState } from 'react';

const faqItems = [
  {
    q: '51暗网吃瓜是什么类型的网站？',
    a: '51暗网吃瓜是一个专注于热门人物爆料与娱乐资讯的聚合平台，聚焦51吃瓜旗下台北娜娜、莫里秀、玩偶姐姐等热门人物，每日更新独家内容与深度专题，为吃瓜爱好者提供最新鲜的一手资讯。',
  },
  {
    q: '网站的爆料内容是否真实可靠？',
    a: '本站内容来源于公开渠道和一手资讯，编辑团队会对信息进行多方核实后发布。但由于信息传播的复杂性，建议读者理性看待，吃瓜有度。我们对所发布的台北娜娜、莫里秀和玩偶姐姐相关内容均标注信息来源。',
  },
  {
    q: '每日更新频率和内容覆盖范围？',
    a: '暗网吃瓜每日更新30+条独家爆料与人物动态，覆盖台北娜娜最新视频、莫里秀黑料揭秘、玩偶姐姐动态追踪等100+热门人物专题，同时定期推出深度回顾和专题合集。',
  },
  {
    q: '如何获取台北娜娜的最新爆料？',
    a: '台北娜娜的所有最新爆料均会第一时间在本站「热门人物专题」和「焦点爆料」栏目中更新。你可以通过首页的专题索引和话题标签快速定位相关内容，也可以关注我们每日更新的快讯列表。',
  },
  {
    q: '玩偶姐姐的视频内容在哪里看？',
    a: '玩偶姐姐相关的精选视频和内容解读集中展示在「独家视频爆料」栏目中，我们会以图文结合的形式呈现核心看点，让你不错过任何精彩内容。同时也可在人物专题索引中找到完整合集。',
  },
  {
    q: '如何向本站投稿或提供线索？',
    a: '欢迎通过页面底部的「爆料投稿」区域或联系邮箱与我们取得联系。我们重视每一条来自吃瓜群众的信息，对于有价值的独家线索将给予优先处理和署名致谢。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          吃瓜常见问答
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          关于51暗网吃瓜，你想知道的都在这里
        </p>
        <div className="mt-8 space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-lg border border-background-200/60 bg-background-100/50 overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}